var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"return-up-route"},[_c('span',{staticClass:"back",on:{"click":_vm.backBtnClick}},[_c('a-icon',{staticClass:"margin-r6",attrs:{"type":"arrow-left"}}),_vm._v("返回 ")],1),_c('span',{staticClass:"margin-r6 margin-l8 color-blue"},[_vm._v("|")]),_c('span',{staticClass:"color-blue"},[_vm._v(_vm._s(_vm.pageName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }